module.exports = __webpack_public_path__ + "assets/img/tel.d4fdbac6.png";